@if (selectedBluePrintField) {
<div class="div-right-panel-component">
  <form #myForm="ngForm">
    <fieldset [disabled]="isReadOnly" style="border: none; padding: 0; margin: 0">
      <mat-form-field>
        <mat-label>Name (Type:{{ selectedBluePrintField.fieldType }})</mat-label>
        <input matInput #inputName maxlength="255" required name="name" (blur)="onNameBlur()" (focus)="selectName()" (keyup)="onChange()" type="text" [(ngModel)]="selectedBluePrintField.name" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Description</mat-label>
        <input matInput type="text" name="description" [(ngModel)]="selectedBluePrintField.description" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Label</mat-label>
        <input matInput name="label" type="text" [placeholder]="selectedBluePrintField.name" [(ngModel)]="selectedBluePrintField.label" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Tooltip</mat-label>
        <input matInput name="tooltip" type="text" [placeholder]="selectedBluePrintField.name" [(ngModel)]="selectedBluePrintField.tooltip" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Default text</mat-label>
        <input matInput type="text" name="defaultText" [(ngModel)]="textField.value" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Max length</mat-label>
        <input matInput type="number" name="maxLength" [(ngModel)]="textField.maxLength" />
      </mat-form-field>
      <div class="checkbox-field">
        <mat-checkbox [(ngModel)]="textField.isRequired" [checked]="textField.isRequired" name="isRequired">Is required?</mat-checkbox>
      </div>
      <div class="checkbox-field">
        <mat-checkbox [(ngModel)]="textField.isReadOnly" [checked]="textField.isReadOnly" name="isReadOnlyCheckbox">Is read-only?</mat-checkbox>
      </div>
      <div class="checkbox-field">
        <mat-checkbox [(ngModel)]="textField.isMasked" [checked]="textField.isMasked" (change)="maskChanged()" name="isMasked">Is masked?</mat-checkbox>
      </div>
    </fieldset>
    <div class="save-button-div" *ngIf="!isReadOnly">
      <button mat-raised-button color="primary" (click)="saveWork()" [disabled]="!myForm.form.valid || !myForm.form.dirty">Save</button>
    </div>
  </form>
</div>
}
